<mat-toolbar class="subtitulo">Controle de Frequência</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">

        <!-- DADOS INICIAIS -->
        <mat-toolbar class="titulopartes">Funcionário</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

            <mat-form-field fxFlexOffset="20px" fxFlex="80%">
                <mat-label>Funcionário que faltou:</mat-label>
                <mat-select [(ngModel)]="faltasFuncionario.funcionarioFaltou.id" name="funcionarioFaltou"
                    (selectionChange)="mostrarDadosFuncionarioQueFaltou($event.value)" required>
                    <mat-option></mat-option>
                    <mat-option *ngFor="let o of funcionarios" [value]="o.id">
                        {{o.pessoasFisica.nome}}
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="funcionarios?.length === 0"  align="start">Nenhum funcionário cadastrado</mat-hint>
            </mat-form-field>
        </div>

        <div *ngIf="faltasFuncionario.funcionarioFaltou.id" style="margin-right: 50px">
            <dados-funcionario [funcionario]=faltasFuncionario.funcionarioFaltou></dados-funcionario>
        </div>
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
            <mat-form-field fxFlexOffset="20px" fxFlex="80%">
                <mat-label>Funcionário que está cadastrando a falta:</mat-label>
                <mat-select [(ngModel)]="faltasFuncionario.funcionarioCadastrouFalta.id"
                    name="funcionarioCadastrouFalta" (selectionChange)="mostrarDadosFuncionario($event.value)" required>
                    <mat-option></mat-option>
                    <mat-option *ngFor="let o of funcionarios" [value]="o.id">
                        {{o.pessoasFisica.nome}}
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="funcionarios?.length === 0"  align="start">Nenhum funcionário cadastrado</mat-hint>
            </mat-form-field>
        </div>

        <div *ngIf="faltasFuncionario.funcionarioCadastrouFalta.id" style="margin-right: 50px">
            <dados-funcionario [funcionario]=faltasFuncionario.funcionarioCadastrouFalta></dados-funcionario>
        </div>


        <!-- FALTAS -->
        <mat-toolbar class="titulopartes">FALTAS</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

            <mat-form-field fxFlex="20%" fxFlexOffset="20px">
                <input matInput name="dataFaltaFuncionario" [matDatepicker]="dataFaltaFuncionario"
                    placeholder="Data da Falta:" [(ngModel)]="faltasFuncionario.dataFaltaFuncionario" (input)="onMascaraDataInput($event)">
                <mat-datepicker-toggle matSuffix [for]="dataFaltaFuncionario"></mat-datepicker-toggle>
                <mat-datepicker #dataFaltaFuncionario></mat-datepicker>
            </mat-form-field>

        </div>

        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

            <mat-form-field style="margin: 0 0 0 20px" fxFlex="45%" appearance="outline">
                <mat-label>Descrição da falta:</mat-label>
                <textarea #descricao matInput name="descricao"  [(ngModel)]="faltasFuncionario.descricao" cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" maxlength="200" required></textarea>
                    <mat-hint align="end">{{descricao.value.length}} / 200</mat-hint>
            </mat-form-field>

            <mat-form-field style="margin: 0 0 0 20px" fxFlex="45%" appearance="outline">
                <mat-label>Justificativa da falta:</mat-label>
                <textarea #jutificativaFalta matInput name="jutificativaFalta"  [(ngModel)]="faltasFuncionario.jutificativaFalta" cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" maxlength="200"></textarea>
                    <mat-hint align="end">{{jutificativaFalta.value.length}} / 200</mat-hint>
            </mat-form-field>

        </div>
       


        <!-- BOTOES -->
        <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
            fxFlexFill>
            <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()"> Cadastrar
            </button>

            <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
                Atualizar
            </button>

            <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                Limpar
            </button>
            <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                Cancelar
            </button>

        </div>
    </form>


</div>